import { render, staticRenderFns } from "./conversation-container.vue?vue&type=template&id=898d9b0e&scoped=true"
import script from "./conversation-container.vue?vue&type=script&lang=js"
export * from "./conversation-container.vue?vue&type=script&lang=js"
import style0 from "./conversation-container.vue?vue&type=style&index=0&id=898d9b0e&prod&lang=less&scoped=true"
import style1 from "./conversation-container.vue?vue&type=style&index=1&id=898d9b0e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898d9b0e",
  null
  
)

export default component.exports